import { CDN_URL, SERVER_ADDRESS } from "../info";
export enum TAGS {
  VendorTags = 1,
  ProductTags = 2,
}

export enum STATUS {
  ProductActive = 12,
  ProductDraft = 11,
  OrderDelivered = 5,
  OrderCancelled = 6,
  OrderConfirmed = 14,
  OrderReturned = 15,
  OrderActivated = 9,
  OrderDispatched = 16,
  OrderCompleted = 28,
}

export const APP_MODULE = {
  ORDER: "order",
  LOGOUT: "logout",
};
// export const BASE_API_URL = "http://localhost:4000";
export const BASE_API_URL = `https://${SERVER_ADDRESS}`;

export enum LOOKUPS {
  VendorLookup = 7,
  UserStatus = 20,
  Mode = 23,
}

export const FILE_TYPE_ID = {
  IMAGE: 1,
  VIDEO: 2,
};

export enum STREAM_STATUS {
  STREAM_CREATED = 34,
  STREAM_STARTED = 35,
  STREAM_ENDED = 36,
}

export enum VIDEO_STATUS {
  VIDEO_IN_PROCESS = 30,
  VIDEO_PUBLISHED = 31,
  VIDEO_ERROR = 32,
}

export enum serviceTypeVendor {
  Catering = 1,
  Grocery = 2,
}

export const DEEP_LINK_BASE_URL = "https://afrocart.ca";
export const MAX_IMAGE_SIZE_MB = 50;
export const MAX_IMAGE_SIZE_BYTES = MAX_IMAGE_SIZE_MB * 1024 * 1024;
export const MAX_VIDEO_SIZE_MB = 100; // Maximum file size in MB
export const MAX_VIDEO_SIZE_BYTES = MAX_VIDEO_SIZE_MB * 1024 * 1024; // Convert MB to bytes
export const AWS_CLOUD_FRONT_URL = CDN_URL;

export const GOOGLE_CALENDAR_AUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth?client_id=163049755710-dtr5st2u2d76c2n31epgr3sb2dc918bh.apps.googleusercontent.com&redirect_uri=${
  BASE_API_URL.split(":8")[0]
}/googleCalenderRedirectPage&response_type=code&scope=openid%20email%20profile%20https://www.googleapis.com/auth/calendar&access_type=offline`;
export const MAX_TAGLINE_LENGTH_MAX = 50;
export const MAX_SERVICETYPE_NAME_LENGTH_MAX = 50;
export const MAX_VENDOR_TAGNAME_LENGTH_MAX = 50;
export const MAX_PRODUCT_TAGNAME_LENGTH_MAX = 50;
export const MAX_CATEGORYNAME_LENGTH_MAX = 50;
export const MAX_SUB_CATEGORYNAME_LENGTH_MAX = 50;
export const MAX_PRODUCT_TAGS_LIMIT = 4;
export const MIN_PASSWORD_LENGTH = 8;
export const MAX_LIVE_STREAM_TITLE_LENGTH = 200;
export const MAX_PRODUCT_IMAGES_UPLOAD = 5;
export const CLICK_UP_TO_SCHEDULE_DELIVERY_HOURS = 2;
export const CLICK_UP_TO_SCHEDULE_DELIVERY_MINS = 0;

export const ModeLookup = {
  DELIVERY: 24,
  VIRTUAL: 25,
  HOME_SERVICE: 26,
  WALK_IN_SERVICE: 27,
};

export const USER_ROLE = {
  ADMIN: "ADMIN",
  VENDOR: "VENDOR",
  CUSTOMER: "CUSTOMER",
};
export enum DEFAULT_LAT_LONG {
  LAT = 43.653225,
  LONG = -79.383186,
}
export const TABWIDTH = 900;
export const OTP_TIME_MILLISEC = 60;

export const ORDER_CANCEL_REASONS = [
  { value: "Duplicate Order", label: "Duplicate Order" },
  { value: "Incorrect Product", label: "Incorrect Product" },
  { value: "Order Placed by Mistake", label: "Order Placed by Mistake" },
  { value: "Fraudulent Order", label: "Fraudulent Order" },
  { value: "Product Unavailable", label: "Product Unavailable" },
  { value: "Shipping Delay", label: "Shipping Delay" },
  { value: "Customer Request", label: "Customer Request" },
  { value: "Other Reason", label: "Other Reason" },
];

export const SERVICE_CANCEL_REASONES = [
  { value: "Service Not as Expected", label: "Service Not as Expected" },
  { value: "Appointment Issue", label: "Appointment Issue" },
  { value: "Provider Unavailable", label: "Provider Unavailable" },
  { value: "Pricing Discrepancy", label: "Pricing Discrepancy" },
  { value: "Miscommunication", label: "Miscommunication" },
  { value: "Delay in Service", label: "Delay in Service" },
  { value: "Customer Request", label: "Customer Request" },
  { value: "Other Reason", label: "Other Reason" },
];

export const REGEXES: any = {
  EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
  PHONE: /^\d{10}$/,
  URL: /^(https?:\/\/)?(www\.)?[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/[^\s]*)?$/,
  PASSWORD: /(?=.*[a-z])(?=.*[A-Z])/,
  POSITIVE_INTEGER_INPUT: /^\d+$/,
  POSITIVE_FLOAT_INPUT: /^\d*\.?\d{0,2}$/,
};

// (?=.*\d)
